var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubcriptionUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5381 26.2242C21.5381 21.3761 16.1328 17.4352 11.2847 17.4352C6.43657 17.4352 1.03125 21.3761 1.03125 26.2242M11.2847 13.042C12.8386 13.042 14.3288 12.4248 15.4275 11.326C16.5263 10.2272 17.1436 8.73701 17.1436 7.18313C17.1436 5.62925 16.5263 4.13901 15.4275 3.04025C14.3288 1.9415 12.8386 1.32422 11.2847 1.32422C9.7308 1.32422 8.24056 1.9415 7.1418 3.04025C6.04304 4.13901 5.42577 5.62925 5.42577 7.18313C5.42577 8.73701 6.04304 10.2272 7.1418 11.326C8.24056 12.4248 9.7308 13.042 11.2847 13.042Z",
    stroke: "#111111",
    strokeWidth: 2.01892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcriptionUser);
export default __webpack_public_path__ + "static/media/subcriptionUser.fff7fd0344fe2efe2bf61f3fa0c1a0f2.svg";
export { ForwardRef as ReactComponent };